export const registrationNotice = {
  enabled: true,
  title: 'Нови групи скоро!',
  message:
    'Akava Academy обновява своите програми и скоро ще обяви нови обучения и практически уебинари.',
  secondaryMessage:
    'Можете да оставите контакт за бъдещи записвания и ранна информация за новите групи.',
} as const;
